import { useState } from "react"
import { mutate } from "swr"
import * as InboundOrderApi from "../../../apis/inbound-order"

const invalidate = () =>
  mutate(
    (key) =>
      Array.isArray(key) &&
      (key[0] === "inbound-orders" ||
        key[0] === "inbound-order" ||
        key[0] === "inbound-exceptions"),
    undefined,
    { revalidate: true },
  )

export function useInboundExceptionMutations() {
  const [submitting, setSubmitting] = useState(false)
  const [error, setError] = useState<Error | null>(null)

  async function wrap<T>(fn: () => Promise<T>): Promise<T> {
    setSubmitting(true)
    setError(null)
    try {
      const r = await fn()
      await invalidate()
      return r
    } catch (e) {
      // HttpHandler is not an Error: keep its message (an `error.*` key) instead of "[object Object]".
      const err = e instanceof Error ? e : new Error((e as { message?: string } | null)?.message ?? String(e))
      setError(err)
      throw err
    } finally {
      setSubmitting(false)
    }
  }

  return {
    submitting,
    error,
    raise: (id: string, body: {
      inboundOrderItemId?: string | null
      exceptionType: string
      expectedQuantity?: number | null
      actualQuantity?: number | null
      conditionObserved?: string | null
      description: string
      photoUrls?: string[]
    }) => wrap(() => InboundOrderApi.raiseException(id, body)),
    start: (id: string, exId: string) =>
      wrap(() => InboundOrderApi.startException(id, exId)),
    resolve: (id: string, exId: string, resolutionNotes: string) =>
      wrap(() => InboundOrderApi.resolveException(id, exId, { resolutionNotes })),
    close: (id: string, exId: string, notes?: string) =>
      wrap(() => InboundOrderApi.closeException(id, exId, { notes })),
  }
}
